import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sidebar"
export default class extends Controller {
  static targets = ["sidebar", "linkText", "toggleIcon"]

  connect() {
    if (localStorage.getItem("sidebarOpen") === "false") {
      this.closeSidebar();
    } else {
      const savedWidth = localStorage.getItem("sidebarWidth")
      if (savedWidth && window.innerWidth >= 768) {
        this.sidebarTarget.style.width = `${savedWidth}px`
        this.sidebarTarget.classList.remove("md:w-[240px]")
      }
    }
  }

  toggle() {
    if (!this.sidebarTarget.classList.contains("md:w-[57px]")) {
      this.closeSidebar();
      localStorage.setItem("sidebarOpen", "false");
    } else {
      this.openSidebar();
      localStorage.setItem("sidebarOpen", "true");
    }
  }

  openSidebar() {
    this.sidebarTarget.classList.remove("md:w-[57px]");
    const savedWidth = localStorage.getItem("sidebarWidth")
    if (savedWidth && window.innerWidth >= 768) {
      this.sidebarTarget.style.width = `${savedWidth}px`
      this.sidebarTarget.classList.remove("md:w-[240px]")
    } else {
      this.sidebarTarget.classList.add("md:w-[240px]");
      this.sidebarTarget.style.width = ""
    }
    this.linkTextTargets.forEach(text => {
      text.classList.remove("hidden");
    });
    if (this.hasToggleIconTarget) {
      this.toggleIconTarget.classList.remove("rotate-180");
    }
  }

  closeSidebar() {
    this.sidebarTarget.classList.remove("md:w-[240px]");
    this.sidebarTarget.classList.add("md:w-[57px]");
    this.sidebarTarget.style.width = ""
    this.linkTextTargets.forEach(text => {
      text.classList.add("hidden");
    });
    if (this.hasToggleIconTarget) {
      this.toggleIconTarget.classList.add("rotate-180");
    }
  }
}
